import { Dropdown } from './Dropdown.js';
import { SingleItem } from './SingleItem.js';
import { useSelectDropdown } from './util.js';
import { jsx } from 'react/jsx-runtime';

/**
 * A dropdown input with filterable options.
 */
function SearchSelectInput(props) {
  // Resources for developing custom combo boxes:
  // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/
  // https://www.24a11y.com/2019/select-your-poison/
  const {
    className: callerClassName,
    disabled,
    id,
    loadingState,
    name,
    options,
    placeholder,
    renderSummary,
    tag,
    value,
    variant = 'default',
    onBlur,
    onChange,
    onFocus,
    onSearch
  } = props;
  const {
    activeOption,
    activeValue,
    closePopover,
    filteredOptions,
    open,
    search,
    searchRef,
    uid,
    onDropdownClick,
    onSearchInput,
    onSearchKeyDown
  } = useSelectDropdown({
    ...props,
    onOptionSelect: handleOptionSelect
  });
  function handleOptionSelect(value) {
    onChange(value);
    closePopover();
  }
  const selectedOption = options.find(option => option.value === value);
  const selectedLabel = renderSummary?.(value) ?? selectedOption?.label;
  const activeLabelOrPlaceholder = activeOption != null ? renderSummary?.(activeValue) ?? activeOption.label : placeholder;
  const activeId = activeValue != null ? `${uid}-option-${activeValue}` : undefined;
  return /*#__PURE__*/jsx(Dropdown, {
    activeId: activeId,
    className: callerClassName,
    closePopover: closePopover,
    disabled: disabled,
    id: id,
    listId: `${uid}-list`,
    loadingState: loadingState,
    name: name,
    open: open,
    placeholder: activeLabelOrPlaceholder,
    search: search,
    searchRef: searchRef,
    selectedLabel: selectedLabel,
    tag: tag,
    tagKey: "data-dsx--search-select-input",
    value: value,
    variant: variant,
    onBlur: onBlur,
    onDropdownClick: onDropdownClick,
    onFocus: onFocus,
    onSearch: onSearch,
    onSearchInput: onSearchInput,
    onSearchKeyDown: onSearchKeyDown,
    children: filteredOptions.length > 0 && filteredOptions.map(option => /*#__PURE__*/jsx(SingleItem, {
      activeValue: activeValue,
      option: option,
      id: `${uid}-option-${option.value}`,
      value: value,
      onSelect: handleOptionSelect
    }, option.value))
  });
}

export { SearchSelectInput };
